import { useLocation } from 'react-router-dom';
import { SEO } from './SEO';

const PLATFORM_SEO: Record<string, { title: string; description: string }> = {
  '/landing': {
    title: 'Rork Store | منصة إنشاء المتاجر الإلكترونية',
    description: 'أنشئ متجرًا إلكترونيًا احترافيًا مع إدارة المنتجات والطلبات والدفع والشحن والتسويق من لوحة واحدة.',
  },
  '/features': {
    title: 'مميزات Rork Store | أدوات متكاملة لنمو متجرك',
    description: 'اكتشف مميزات Rork Store لإدارة المنتجات، الطلبات، العملاء، التسويق، الشحن، الدومين، التقارير والقوالب.',
  },
  '/pricing': {
    title: 'أسعار Rork Store | خطط شهرية وسنوية للمتاجر',
    description: 'قارن خطط Rork Store الشهرية والسنوية واختر الباقة المناسبة لإطلاق أو تطوير متجرك الإلكتروني.',
  },
  '/about': {
    title: 'عن Rork Store | منصة تجارة إلكترونية عربية',
    description: 'تعرف على Rork Store ورؤيتنا في تسهيل إنشاء وإدارة المتاجر الإلكترونية لأصحاب الأعمال.',
  },
  '/blog': {
    title: 'مدونة Rork Store | نصائح التجارة الإلكترونية',
    description: 'مقالات ونصائح عملية لتحسين متجرك الإلكتروني وزيادة المبيعات وتجربة العملاء.',
  },
  '/help': {
    title: 'مركز المساعدة | Rork Store',
    description: 'دليل مساعدة Rork Store للإجابة على الأسئلة الشائعة حول إنشاء وإدارة المتجر.',
  },
  '/docs': {
    title: 'توثيق Rork Store | دليل الاستخدام والتكامل',
    description: 'تعلم كيفية استخدام Rork Store وإعداد المتجر والميزات والتكاملات خطوة بخطوة.',
  },
  '/api': {
    title: 'واجهة API | Rork Store',
    description: 'تعرف على واجهات API العامة في Rork Store للمتاجر والمنتجات والطلبات.',
  },
  '/partners': {
    title: 'شركاء Rork Store | فرص التعاون',
    description: 'انضم إلى برنامج شركاء Rork Store وساعد أصحاب الأعمال على إطلاق متاجرهم الإلكترونية.',
  },
  '/marketers': {
    title: 'برنامج المسوقين | Rork Store',
    description: 'انضم لبرنامج المسوقين في Rork Store واربح من إحالة التجار إلى المنصة.',
  },
  '/faq': {
    title: 'الأسئلة الشائعة | Rork Store',
    description: 'إجابات مختصرة على أكثر الأسئلة الشائعة حول خطط Rork Store والمتاجر والدفع والدعم.',
  },
  '/terms': {
    title: 'الشروط والأحكام | Rork Store',
    description: 'اطلع على شروط وأحكام استخدام منصة Rork Store.',
  },
  '/privacy': {
    title: 'سياسة الخصوصية | Rork Store',
    description: 'تعرف على كيفية تعامل Rork Store مع بيانات المستخدمين والمتاجر والعملاء.',
  },
  '/refund': {
    title: 'سياسة الاسترداد | Rork Store',
    description: 'سياسة الاسترداد والاشتراكات والمدفوعات الخاصة بمنصة Rork Store.',
  },
  '/commercial-terms': {
    title: 'الشروط التجارية | Rork Store',
    description: 'الشروط التجارية الخاصة باستخدام خدمات Rork Store للمتاجر والاشتراكات.',
  },
  '/videos': {
    title: 'فيديوهات تعليمية | Rork Store',
    description: 'شروحات فيديو تساعدك على استخدام Rork Store وإدارة متجرك بكفاءة.',
  },
};

export function PlatformRouteSEO() {
  const location = useLocation();
  const meta = PLATFORM_SEO[location.pathname];

  if (!meta) return null;

  return (
    <SEO
      title={meta.title}
      description={meta.description}
      canonicalPath={location.pathname}
      structuredData={{
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'Rork Store',
        url: typeof window !== 'undefined' ? window.location.origin : undefined,
        inLanguage: 'ar',
      }}
    />
  );
}
